// @flow
import * as React from "react"
import keymirror from "keymirror"
import MdFlight from "react-icons/lib/md/flight"
import MdTrain from "react-icons/lib/md/train"
import MdDirectionsBus from "react-icons/lib/md/directions-bus"

export const RESERVATION_ERRORS = {
  REQUIRED: __("forms.errors.is_required"),
  REQUIRED_EMAIL: __("booking.passenger.email.required"),
  INVALID: __("forms.errors.invalid_value"),
  INVALID_EMAIL: __("booking.passenger.email.invalid"),
  NOT_SUPPORTED: __("forms.errors.not_supported"),
  EXPIRED: __("forms.expired"),
  EXPIRES_BEFORE_DEPARTURE: __("forms.expires_before_departure"),
  RANGE: __("forms.must_be_in_range"),
  LEAST: __("forms.must_be_at_least"),
  SHORT: __("forms.too_short"),
  LONG: __("forms.too_long"),
  INVALID_BIRTHDAY: __("forms.errors.invalid_birthday"),
  CURRENCIES_WHITELIST: __("common.payment.provider_supported_currency"),
  INVALID_EXPIRATION_DATE: __("forms.errors.invalid_expiration_date"),
  TERMS: __("booking.global.agreement.terms_error"),
  ID_NUMBER_TOO_LONG: __("forms.id_number_too_long"),
  INVALID_CPF: __("forms.errors.invalid_cpf"),
}

export const RESERVATION_BILLING_DETAILS_TYPES = keymirror({
  COMPANY: null,
  PERSON: null,
})

// Reservation Flight part
// ===
export const PART_TYPES = {
  FLIGHT: "flight",
  TRAIN: "train",
  BUS: "bus",
}

export type PART_TYPE = "flight" | "train" | "bus"

export type PART_CONFIG_TYPE = {
  [key: PART_TYPE]: {
    type: PART_TYPE,
    icon?: React.Element<*>,
    logo: string,
  },
}

export const RESERVATION_PART_CONFIG: PART_CONFIG_TYPE = {
  flight: {
    type: PART_TYPES.FLIGHT,
    icon: <MdFlight className="ItineraryPart-milestoneIcon _flight" />,
    logo: "skypicker",
  },
  train: {
    type: PART_TYPES.TRAIN,
    icon: <MdTrain className="ItineraryPart-milestoneIcon _train" />,
    logo: "train",
  },
  bus: {
    type: PART_TYPES.BUS,
    icon: <MdDirectionsBus className="ItineraryPart-milestoneIcon _bus" />,
    logo: "bus",
  },
}

// Baggages
// ===
// NOTE: not using keymirror intentionally, because of IDE autocompletion
export const BAGGAGE_AVAILABILITY: { [key: string]: string } = {
  FREE: "FREE",
  PAID_FOR_OPTION: "PAID_FOR_OPTION",
  NOT_AVAILABLE: "NOT_AVAILABLE",
}

export const BAGGAGE_TYPE: { [key: string]: string } = {
  PERSONAL: "PERSONAL",
  CABIN: "CABIN",
  CHECKED: "CHECKED",
}

/**
 * Countries which have reversed names (Given names, Surname) => (Surname, Given names):
 * kr - Korea
 * jp - Japan
 * cn - China
 * vn - Vietnam
 * hu - Hungary
 * kh - Cambodia
 * tw - Taiwan
 */
export const REVERSED_NAMES_ORDER_COUNTRIES = ["ko", "ja", "cn", "vn", "hu", "kh", "tw"]

/**
 * Countries within Cuba regulations:
 * US - United States
 * AS - American Samoa
 * GU - Guam
 * MP - Northern Mariana Islands
 * PR - Puerto Rico
 * VI - U.S. Virgin Islands
 */
export const US_CUBA_REGULATION_COUNTRIES = ["US", "AS", "GU", "MP", "PR", "VI"]

// Pay Tracking intervals in seconds
export const PAY_TRACKING_INTERVALS = {
  retry: 2,
  long: 30,
  terminated: 60,
}

// Promocode
// ===

// Error responses from promocode api
export type RESERVATION_PROMOCODE_ERROR_CODES =
  | "error_wrong_email"
  | "error_unknown"
  | "error_used"
  | "error_expired"
  | "error_authorized"
  | "error_app_only"
  | "error_browser_only"
  | "error_region"
  | "error_language"
  | "error_depleted"
  | "error_deactivated"
  | "error_price_threshold"

// Save Booking consts
// ===
export const SAVE_BOOKING_ERRORS = {
  DUPLICATE_BOOKING: "duplicate booking",
  CANT_ORDER_ANYMORE: "can't order anymore",
  PROMOCODE_USED: "promocode already used",
  RESERVATION_FAILED: "reservation process failed",
  RESERVATION_PROCESS_ERROR: "error during reservation process",
  PAYMENT_CANCELLED: "blocked_by_decision_engine",
}
// TODO: remove upperCase cancelled after BE removes it
export const SAVE_BOOKING_ERROR_STATUSES = ["error", "Cancelled", "cancelled"]

export const CONTEXT_BOOKING = {
  MULTISTEP: "MULTISTEP_BOOKING",
}

export const NAME_CORRECTION_PROBABILITY = 0.8
